import { Box, Button, Heading } from '@ksyos/design-system';
import { useNavigate } from '@ksyos/router';
import { useEffect, useState } from 'react';
import type { IRequest } from '../../../../../common/interfaces/request';
import { translateKey } from '../../../../translate';
import { useAbortableFetch } from '../../../../utils/hooks/useAbortableFetch';
import { RequestsList } from '../../requests/requestsList/RequestsList';

export function HomeTaskList(): JSX.Element | null {
    const navigate = useNavigate();
    const abortableFetch = useAbortableFetch();
    const [requests, setRequests] = useState<IRequest[]>();

    useEffect(() => {
        loadRequests();
    }, []);

    if (!requests) {
        return null;
    }

    return (
        <>
            <Box
                alignItems="center"
                className="homeTaskList"
                display="flex"
                justifyContent="space-between"
                pb={8}
                pt={10}
            >
                <Heading size="large">{translateKey('request.mostRecentTasks')}</Heading>
                <Button
                    iconRight="caret-right"
                    onClick={onClick}
                    variant="link"
                >
                    {translateKey('request.viewAllTasks')}
                </Button>
            </Box>
            <RequestsList requests={requests} />

            {requests.length === 0 && (
                <Box
                    mb={6}
                    textAlign="center"
                >
                    <Heading size="xlarge">{translateKey('request.emptyMyRequestsWorklist')}</Heading>
                </Box>
            )}
        </>
    );

    async function loadRequests() {
        const url =
            '/api/requests/worklist?page=1&limit=5&includeItemAuthorizations=canSeeRequesterAndCareProviderContext&workListFilter=myRequests&excludeTotal=true&includeInactives=false';
        const result = await abortableFetch.fetchJson(url, 'GET');

        setRequests(result.json.items);
    }

    function onClick() {
        navigate('/requests#search');
    }
}
